import React from 'react'
// import { Link } from 'react-router-dom'
import styles from '../CardAgenda/CardAgenda.module.css'

const CardAgenda = (props) => {
    return (

            <div className={`${styles.cardArtistePrecis}  rounded-lg mx-3 my-5 shadow-lg`}>
                <div className="cardNew">

                    <div className="card-body">
                        <div >
                            <h5 className="card-title">
                                {props.NameArtist} 
                            </h5>
                            <div className="bg-danger rounded-pill d-inline p-2 text-white m-1 ">
                                {props.CategorieArtiste}
                            </div>
                        </div>
                    </div>
                    
                    <div > 
                        <figure>
                            <img className='img-fluid'  style={{backgroundImage: `url(${props.imgbg})`, height: 786+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} alt={props.altimg} />
                        </figure>
                    </div>
                    
                </div>
            </div>
    )
}

export default CardAgenda


